import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

// German resources
import de from "./lang/de/de.json";
// English resources
import en from "./lang/en/en.json";
// French resources
import fr from "./lang/fr/fr.json";
// Norwegian resources
import nb from "./lang/nb/nb.json";

import { LANG_KEY } from "../utils/localStorage";

export const resources = {
  en: {
    translation: en,
  },
  de: {
    translation: de,
  },
  fr: {
    translation: fr,
  },
  nb: {
    translation: nb,
  },
} as const;

const langDetectionOptions = {
  // order and from where user language should be detected
  order: [
    "querystring",
    "cookie",
    "localStorage",
    "sessionStorage",
    "navigator",
    "htmlTag",
    "path",
    "subdomain",
  ],

  // keys or params to lookup language from
  lookupQuerystring: "lng",
  lookupCookie: LANG_KEY,
  lookupLocalStorage: LANG_KEY,
  lookupSessionStorage: LANG_KEY,
  lookupFromPathIndex: 0,
  lookupFromSubdomainIndex: 0,

  // cache user language on
  caches: ["localStorage", "cookie"],
  excludeCacheFor: ["cimode"], // languages to not persist (cookie, localStorage)

  // optional expire and domain for set cookie
  cookieMinutes: 10,
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: langDetectionOptions,
    debug: false,
    initAsync: false,
    preload: ["nb", "en", "de", "fr"],
    keySeparator: false,
    fallbackLng: "en",
    resources,
  });
